import React, {Component} from 'react';
import {
        PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN
} from "../../../../../App/RouterAdopta";
import {Helmet} from "react-helmet";
import {createJSONSchemaProtectora} from "../../../../Shared/components/components/schema_org_helper";

class AnimalShelter_Schema_org extends Component {
    
    constructor(props, context) {
        super(props, context);
        
    }
    
    render() {
        return (
            <Helmet>
                <script id="animalshelter_jsonld" type="application/ld+json" data-testid="json-ld-script">
                    {JSON.stringify(createJSONSchemaProtectora(this.props.infoEntity,this.props.HOST, PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN))}
                </script>
            </Helmet>
        );
    }
    
    componentWillMount() {
    
    }
    
    componentDidMount() {
    
    
    }
    
    componentDidUpdate() {
    
    }
    
    
}

export default AnimalShelter_Schema_org
